import { CreateCompanyFormState } from './CreateCompanyForm';

export const initialFormState: CreateCompanyFormState = {
	name: '',
	emailDomains: [],
	countryCode: '',
	youniumId: '',
	hubspotId: '',
	youniumAccountNumber: '',
	isCustomer: false,
};
